import {
  CoachSessionRemarkV2,
  coachSessionRemarkV2Schema,
  getCoachSessionsSortOrderSchema,
} from '@airreading/common/data';
import { z } from 'zod';
import { paginationRequestSchema } from './pagination';

export const coachSessionListSearchSchema = paginationRequestSchema.extend({
  startOnOrAfter: z.string().optional(),
  endOnOrBefore: z.string().optional(),
  query: z.string().optional(),
  sortBy: getCoachSessionsSortOrderSchema.optional(),
  sessionRemarksV2: z.array(coachSessionRemarkV2Schema).optional(),
});
export type CoachSessionListRouteConstraint = z.infer<typeof coachSessionListSearchSchema>;

/** Views persisted in URL; includes legacy react-big-calendar names during Schedule-X migration. */
export const coachCalendarLegacyViewSchema = z.enum(['month', 'week', 'work_week', 'day', 'agenda']);

export const coachCalendarSearchSchema = z.object({
  view: coachCalendarLegacyViewSchema.optional(),
  date: z.string().optional(),
});

export type CoachCalendarRouteConstraint = z.infer<typeof coachCalendarSearchSchema>;

/** Views supported by SessionScheduleCalendar (RBC + Schedule-X). Canonical list; `CalendarView` in session-schedule-calendar-types is an alias. */
export const coachCalendarSupportedViews = ['month', 'week', 'day'] as const;
export type CoachCalendarView = (typeof coachCalendarSupportedViews)[number];

/** Maps legacy RBC search params to the shared calendar view type. */
export function normalizeCoachCalendarView(
  view: z.infer<typeof coachCalendarLegacyViewSchema> | undefined,
): CoachCalendarView {
  if (view === 'month' || view === 'week' || view === 'day') {
    return view;
  }
  return 'week';
}

/** Default session-remark filters for the coach classes calendar (aligned with past classes list). */
export const coachCalendarDefaultSessionRemarksV2: CoachSessionRemarkV2[] = [
  CoachSessionRemarkV2.canceledWithin12Hours,
  CoachSessionRemarkV2.endEarly,
  CoachSessionRemarkV2.lateStart,
  CoachSessionRemarkV2.subClass,
  CoachSessionRemarkV2.subClassWithin12Hours,
];
